// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// Footer menus retain native localization form submission and a no-JS details fallback.
(() => {
  let opened, sequence = 0;
  function enhance() {
    document.querySelectorAll('.sp-footer .sp-language-picker:not([data-enhanced])').forEach(host => {
      const trigger = host.querySelector('summary');
      const menu = host.querySelector('.sp-language-picker__options');
      const buttons = [...menu.querySelectorAll('button')];
      host.dataset.enhanced = 'true';
      // Keep details open so CSS can animate both directions; inert removes closed options.
      host.open = true;
      menu.id = `sp-localization-options-${++sequence}`;
      menu.setAttribute('role', 'menu');
      trigger.setAttribute('aria-controls', menu.id);
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-haspopup', 'menu');
      trigger.setAttribute('aria-expanded', 'false');
      menu.inert = true;
      buttons.forEach(button => {
        button.tabIndex = -1;
        button.setAttribute('role', 'menuitemradio');
        button.setAttribute('aria-checked', String(button.getAttribute('aria-current') === 'true'));
      });
      function focusOption(button) {
        button?.focus({ preventScroll: true });
        if (!button) return;
        // Scroll only the menu, never the footer or document.
        const top = button.offsetTop, bottom = top + button.offsetHeight;
        if (top < menu.scrollTop) menu.scrollTop = top;
        else if (bottom > menu.scrollTop + menu.clientHeight) menu.scrollTop = bottom - menu.clientHeight;
      }
      function close(restore = false) {
        host.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        menu.inert = true;
        if (restore) trigger.focus({ preventScroll: true });
        if (opened?.host === host) opened = null;
      }
      function open() {
        opened?.close();
        host.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.inert = false;
        opened = { host, close };
        focusOption(buttons.find(button => button.getAttribute('aria-current') === 'true') || buttons[0]);
      }
      trigger.addEventListener('click', event => {
        event.preventDefault();
        host.classList.contains('is-open') ? close() : open();
      });
      let typed = '', typedAt = 0;
      host.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(true); return; }
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          if (!host.classList.contains('is-open')) { open(); return; }
          const current = buttons.indexOf(document.activeElement);
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + (event.key === 'ArrowUp' ? -1 : 1) + buttons.length) % buttons.length;
          focusOption(buttons[next]);
        } else if (event.key.length === 1 && event.key !== ' ' && !event.ctrlKey && !event.metaKey && !event.altKey) {
          event.preventDefault();
          if (!host.classList.contains('is-open')) open();
          typed = Date.now() - typedAt > 700 ? event.key : typed + event.key;
          typedAt = Date.now();
          focusOption(buttons.find(button => button.textContent.trim().toLocaleLowerCase().startsWith(typed.toLocaleLowerCase())));
        }
      });
    });
  }
  document.addEventListener('pointerdown', event => { if (opened && !opened.host.contains(event.target)) opened.close(); });
  document.addEventListener('focusin', event => { if (opened && !opened.host.contains(event.target)) opened.close(); });
  document.addEventListener('shopify:section:load', enhance);
  enhance();
})();

// Enhance native sort selects; the original field still submits through Dawn's facets.
(() => {
  let opened;
  let sequence = 0;
  function enhance(root) {
    const selects = root.matches?.('select[name="sort_by"]') ? [root] : root.querySelectorAll?.('select[name="sort_by"]') || [];
    selects.forEach(select => {
      const host = select.parentElement;
      if (host.classList.contains('sp-sort-select')) return;
      host.classList.add('sp-sort-select');
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'sp-sort__trigger';
      trigger.id = `sp-sort-trigger-${++sequence}`;
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');
      const label = [...select.labels].map(item => item.textContent.trim()).join(' ') || 'Sortieren';
      [...select.labels].forEach(item => item.htmlFor = trigger.id);
      const menu = document.createElement('div');
      menu.className = 'sp-sort__options';
      menu.id = `sp-sort-options-${sequence}`;
      menu.setAttribute('role', 'listbox');
      menu.setAttribute('aria-label', label);
      menu.inert = true;
      trigger.setAttribute('aria-controls', menu.id);
      const buttons = [...select.options].map(option => {
        const button = document.createElement('button');
        button.type = 'button';
        button.tabIndex = -1;
        button.setAttribute('role', 'option');
        button.textContent = option.text;
        button.disabled = option.disabled;
        button.addEventListener('click', () => {
          const changed = select.value !== option.value;
          select.value = option.value;
          sync();
          close(true);
          if (changed) select.dispatchEvent(new Event('input', { bubbles: true }));
        });
        menu.append(button);
        return button;
      });
      function sync() {
        trigger.textContent = select.selectedOptions[0]?.text || '';
        trigger.setAttribute('aria-label', `${label} ${trigger.textContent}`);
        buttons.forEach((button, index) => button.setAttribute('aria-selected', String(index === select.selectedIndex)));
      }
      function close(restoreFocus = false) {
        host.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        menu.inert = true;
        if (restoreFocus) trigger.focus({ preventScroll: true });
        if (opened?.host === host) opened = null;
      }
      function open() {
        opened?.close();
        host.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
        menu.inert = false;
        opened = { host, close };
      }
      trigger.addEventListener('click', () => host.classList.contains('is-open') ? close() : open());
      host.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); close(true); return; }
        if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (!host.classList.contains('is-open')) open();
        const current = buttons.indexOf(document.activeElement);
        let index = current < 0 ? select.selectedIndex : current + (event.key === 'ArrowUp' ? -1 : 1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = buttons.length - 1;
        buttons[(index + buttons.length) % buttons.length]?.focus({ preventScroll: true });
      });
      select.addEventListener('change', sync);
      host.append(trigger, menu);
      select.hidden = true;
      sync();
    });
  }
  document.addEventListener('pointerdown', event => { if (opened && !opened.host.contains(event.target)) opened.close(); });
  document.addEventListener('focusin', event => { if (opened && !opened.host.contains(event.target)) opened.close(); });
  enhance(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) enhance(node);
  }))).observe(document.body, { childList: true, subtree: true });
})();

// A new outward swipe at an edge wraps to the other end. Vertical scrolling stays native.
(() => {
  // Endlos-Umschlag nur fuer die grossen Produkt-Slider. Produktkarten-Galerien sind
  // bewusst ausgenommen: dort liess ein kurzer Wisch nach rechts auf das letzte Bild
  // springen (scrollTo greift trotz overflow:hidden) - fuer Kunden ein Bug, kein Feature.
  const selector = '.related-products .product-grid,.collection .product-grid.slider';
  const bound = new WeakSet();
  function enhance(root) {
    const tracks = root.matches?.(selector) ? [root] : root.querySelectorAll?.(selector) || [];
    tracks.forEach(track => {
      if (bound.has(track)) return;
      bound.add(track);
      let start, wheel, suppressClick = false;
      const edge = () => {
        const max = track.scrollWidth - track.clientWidth;
        return { max, first: track.scrollLeft <= 2, last: track.scrollLeft >= max - 2 };
      };
      const direction = (state, dx, dy) => state?.max > 2 && Math.abs(dx) > 32 && Math.abs(dx) > Math.abs(dy) * 1.3 && ((state.last && dx > 0) || (state.first && dx < 0));
      const wrap = state => {
        track.scrollTo({ left: state.last ? 0 : state.max, behavior: 'instant' });
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) track.animate([{ opacity: .7 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
      };
      track.addEventListener('touchstart', event => {
        if (event.target.closest(selector) !== track) return;
        if (event.touches.length !== 1) { start = null; return; }
        const touch = event.touches[0];
        start = { ...edge(), x: touch.clientX, y: touch.clientY };
      }, { passive: true });
      track.addEventListener('touchend', event => {
        if (!start || !event.changedTouches.length) return;
        const touch = event.changedTouches[0];
        if (direction(start, start.x - touch.clientX, start.y - touch.clientY)) {
          suppressClick = true;
          setTimeout(() => { suppressClick = false; }, 350);
          wrap(start);
        }
        start = null;
      }, { passive: true });
      track.addEventListener('touchcancel', () => { start = null; }, { passive: true });
      track.addEventListener('click', event => { if (suppressClick) { event.preventDefault(); event.stopPropagation(); } }, true);
      track.addEventListener('wheel', event => {
        if (event.target.closest(selector) !== track) return;
        const now = performance.now();
        if (!wheel || now - wheel.time > 240) wheel = { ...edge(), dx: 0, dy: 0, wrapped: false };
        wheel.time = now;
        wheel.dx += event.deltaX;
        wheel.dy += event.deltaY;
        if (wheel.wrapped && Math.abs(event.deltaX) > Math.abs(event.deltaY)) { event.preventDefault(); return; }
        if (!wheel.wrapped && direction(wheel, wheel.dx, wheel.dy)) { event.preventDefault(); wheel.wrapped = true; wrap(wheel); }
      }, { passive: false });
    });
  }
  enhance(document);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
    if (node.nodeType === 1) enhance(node);
  }))).observe(document.body, { childList: true, subtree: true });
})();
